import React from 'react';
import Relay from 'react-relay';
import mergeWith from 'lodash/mergeWith'
import pickBy from 'lodash/pickBy'

import Button from '../../components/Button';
import UserTable from '../../components/UserTable';
import { isValidEmailAddress } from '../../components/UserPanel';
import ValidateUserMutation from '../../mutations/User/ValidateUserMutation';
import UpdateUserMutation from '../../mutations/User/UpdateUserMutation';
import UserItem from '../../components/UserItem';

const pageSize = 100;

class UserList extends React.Component {

  state = {
    search: '',
    loading: false,
    hasNextPage: false,
    hasPreviousPage: false,
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setState({
      loading: true,
    })
    this.props.relay.setVariables({
      next: true
    }, readyState => {
      if (readyState.done) {
        this.setState({
          loading: false
        })
      }
    })
  }

  componentWillMount(){
    this.componentWillReceiveProps(this.props)
  }

  componentWillReceiveProps(nextProps) {

    if (this.state.loading) return false

    const existFirst = (objValue, srcValue) => objValue? objValue : srcValue
    const propsWithDefaults = mergeWith(nextProps, this.state, existFirst)
    const { search, searchByUserType, searchBySportId, searchBySportLevel } = propsWithDefaults
    const hasNextPage = nextProps.viewer.next ? nextProps.viewer.next.pageInfo.hasPreviousPage : this.state.hasNextPage;
    const hasPreviousPage = nextProps.viewer.prev ? nextProps.viewer.prev.pageInfo.hasNextPage : this.state.hasPreviousPage;
    this.setState({
      hasNextPage,
      hasPreviousPage
    })
    const variables = {}

    if (search !== this.props.search || search !== this.state.search) {
      if (isValidEmailAddress(search)) {
        variables.email = search
      } else {
        variables.pseudo = search
      }
      if (search !== this.state.search) {
        this.setState({
          search
        })
      }
    }

    if (searchByUserType != this.props.relay.variables.userType) {
      variables.userType = searchByUserType
    }

    if (searchBySportId && (searchBySportId != (this.props.relay.variables.sport || {}).sportID)) {
      variables.sport = { sportID: searchBySportId }
    }


    if (searchBySportId && searchBySportLevel && searchBySportLevel != (this.props.relay.variables.sport || {}).level) {
      variables.sport = {
        sportID: searchBySportId,
        level: searchBySportLevel,
      }
    }
    if (Object.keys(variables).length) {
      this.setState({
        loading: true,
      })
      variables.next = true ;
      this.props.relay.setVariables(variables, this.dataFetched)
    }
  }

  dataFetched = ({ done, aborted }) => {
    if (done || aborted)  {
      this.setState({ loading: false }, () => this.componentWillReceiveProps(this.props))
    }
  }

  nextPage() {
    const hasPreviousPage = true;
    const hasNextPage = false;

    const pageInfo = this.props.viewer.next ? this.props.viewer.next.pageInfo : this.props.viewer.prev.pageInfo;
    const cursor = pageInfo.startCursor;
    this.setState({ hasPreviousPage, hasNextPage, loading: true })
    this.props.relay.setVariables({
      before: cursor,
      next: true,
      prev: false
    }, this.dataFetched);
  }

  prevPage() {
    const hasNextPage = true;
    const hasPreviousPage = false;
    const pageInfo = this.props.viewer.prev ? this.props.viewer.prev.pageInfo : this.props.viewer.next.pageInfo;
    const cursor = pageInfo.endCursor;
    this.setState({ hasPreviousPage, hasNextPage, loading: true })
    this.props.relay.setVariables({
      after: cursor,
      next: false,
      prev: true
    }, this.dataFetched);
  }

  assetEdges() {
    // get the next edges or the prev edges, or just get an empty array
    return (this.props.viewer ?
      (this.props.viewer.next ? this.props.viewer.next.edges.map(edge => edge.node) :
        (this.props.viewer.prev ? this.props.viewer.prev.edges.map(edge => edge.node) : []))
      : [])
  }

  onEditUserClick(item, index) {
    if(item == this.props.location.state.user){
      return;
    }

    let path = '/users/edit';
    this.props.router.push({
      pathname : path,
      state :{
        userId:item.id,
      }
    })
  }


  render() {
    if (this.state.loading) return (<div>Loading...</div>)

    const prevButton = this.state.hasPreviousPage ? <button onClick={ this.prevPage.bind(this) }>Prev</button> : '';
    const nextButton = this.state.hasNextPage ? <button onClick={ this.nextPage.bind(this) }>Next</button> : '';

    // const users = this.props.viewer.users.edges;
    const users = this.assetEdges();
    let filter = this.props.location.state.filter;

    return (
      <div>
         <UserTable
          dataSource={users}
          filter={filter}
          viewer={this.props.viewer}
          onItemClick={this.onEditUserClick.bind(this)}
        />
        
        {this.props.children}
        { prevButton } { nextButton }
      </div>
    );

  }

}

UserList.propTypes = ({
  viewer: React.PropTypes.object.isRequired,
  relay: React.PropTypes.object.isRequired,
  children: React.PropTypes.node,
});

export default Relay.createContainer(UserList, {
  initialVariables: {
    first: pageSize,
    last: pageSize,
    after: null,
    before: null,
    next: false,
    prev: false,
    pseudo: null,
    email: null,
    sport: null,
    userType: null,
  },

  fragments: {
    viewer: (variables) => Relay.QL`
      fragment on Viewer {
        ${UserItem.getFragment('viewer')}
        ${ValidateUserMutation.getFragment('viewer')}
        next: users(last: $last, before: $before, email: $email, pseudo: $pseudo, sport: $sport, userType: $userType) @include(if: $next) {
          edges {
            node {
              id
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }

        prev: users(first: $first, after: $after) @include(if: $prev) {
          edges {
            node {
              id
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
        
      }
      `,
  }
});



// WEBPACK FOOTER //
// ./src/pages/User/UsersList.js